//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  model: {
    prop: 'systemBetSelection',
    event: 'change'
  },
  props: {
      systemBetSelection: {
        required: false,
        default: null
    },
    value: {
      default: undefined
    },
    betType: {
      default: 'single'
    },
    selections: {
      default: []
    },
    systemBetChoices: {
      default: []
    }
  }
}
